import { Icon_default } from "./chunk-BTGG6N6L.js";

// src/elements/Icon/helpers.tsx
import React from "react";
var renderIcon = icon => typeof icon === "string" ? /* @__PURE__ */React.createElement(Icon_default, {
  icon
}) : icon;
export { renderIcon };